import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDDPCall } from '@zedoc/ddp-connector';
import { useTranslation, Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { submit } from 'redux-form';
import Stack from '../../../../common/components/primitives/Stack';
import EditNoteForm, {
  form,
} from '../../../../components/dialogs/EditNote/EditNoteForm';
import Text from '../../../../common/components/base/Text';
import { notifyError } from '../../../../utils/notify';
import { insertNote } from '../../../../common/api/collections/AnswersSheets';
import { SIGNED_NOTE_TYPE__RESOLVED } from '../../../../common/constants';
import Dialog from '../../../../components/Dialog';

const DashboardResolveModal = ({
  visible,
  onCancel,
  answersSheetId,
  patientName,
}) => {
  const { t } = useTranslation();
  const { ddpCall, ddpIsPending } = useDDPCall();
  const onSubmit = useCallback(
    ({ noteContent }) => {
      ddpCall(
        insertNote.withParams({
          answersSheetId,
          noteContent,
          noteType: SIGNED_NOTE_TYPE__RESOLVED,
        }),
      )
        .then(() => {
          onCancel();
        })
        .catch(notifyError());
    },
    [ddpCall, answersSheetId, onCancel],
  );
  const dispatch = useDispatch();
  const handleOnOk = useCallback(() => dispatch(submit(form)), [dispatch]);
  return (
    <>
      <Dialog
        title={t('confirmations:resolveStatus.title')}
        visible={visible}
        onOk={handleOnOk}
        onCancel={onCancel}
        loading={ddpIsPending}
      >
        <Stack>
          <Text.Paragraph>
            <Trans i18nKey="confirmations:resolveStatus.descriptionWithName">
              <Text.Span importance="high">
                {{
                  recipientName: patientName,
                }}
              </Text.Span>
            </Trans>
          </Text.Paragraph>
          <EditNoteForm onSubmit={onSubmit} />
        </Stack>
      </Dialog>
    </>
  );
};

DashboardResolveModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  answersSheetId: PropTypes.string,
  patientName: PropTypes.string,
};

DashboardResolveModal.defaultProps = {
  visible: true,
  onCancel: null,
  answersSheetId: null,
  patientName: null,
};

export default DashboardResolveModal;
